import type { SupportedLocale } from '@fleetcore/shared'

import authAr from './locales/ar/auth.json'
import commonAr from './locales/ar/common.json'
import dashboardAr from './locales/ar/dashboard.json'
import diagnosticsAr from './locales/ar/diagnostics.json'
import errorsAr from './locales/ar/errors.json'
import mapAr from './locales/ar/map.json'
import navAr from './locales/ar/nav.json'
import tripsAr from './locales/ar/trips.json'
import vehiclesAr from './locales/ar/vehicles.json'
import authEn from './locales/en/auth.json'
import commonEn from './locales/en/common.json'
import dashboardEn from './locales/en/dashboard.json'
import diagnosticsEn from './locales/en/diagnostics.json'
import errorsEn from './locales/en/errors.json'
import mapEn from './locales/en/map.json'
import navEn from './locales/en/nav.json'
import tripsEn from './locales/en/trips.json'
import vehiclesEn from './locales/en/vehicles.json'
import authFr from './locales/fr/auth.json'
import commonFr from './locales/fr/common.json'
import dashboardFr from './locales/fr/dashboard.json'
import diagnosticsFr from './locales/fr/diagnostics.json'
import errorsFr from './locales/fr/errors.json'
import mapFr from './locales/fr/map.json'
import navFr from './locales/fr/nav.json'
import tripsFr from './locales/fr/trips.json'
import vehiclesFr from './locales/fr/vehicles.json'

export const NAMESPACES = [
  'common',
  'auth',
  'nav',
  'dashboard',
  'vehicles',
  'map',
  'trips',
  'diagnostics',
  'errors',
] as const
export type Namespace = (typeof NAMESPACES)[number]

export const DEFAULT_NAMESPACE: Namespace = 'common'

/**
 * Catalogs are bundled, not fetched. Three languages of flat JSON weigh a few
 * kilobytes; lazy-loading them would trade that for a flash of untranslated keys
 * on the login screen, which is the first thing a customer ever sees.
 */
export const resources: Record<SupportedLocale, Record<Namespace, object>> = {
  fr: {
    common: commonFr,
    auth: authFr,
    nav: navFr,
    dashboard: dashboardFr,
    vehicles: vehiclesFr,
    map: mapFr,
    trips: tripsFr,
    diagnostics: diagnosticsFr,
    errors: errorsFr,
  },
  en: {
    common: commonEn,
    auth: authEn,
    nav: navEn,
    dashboard: dashboardEn,
    vehicles: vehiclesEn,
    map: mapEn,
    trips: tripsEn,
    diagnostics: diagnosticsEn,
    errors: errorsEn,
  },
  ar: {
    common: commonAr,
    auth: authAr,
    nav: navAr,
    dashboard: dashboardAr,
    vehicles: vehiclesAr,
    map: mapAr,
    trips: tripsAr,
    diagnostics: diagnosticsAr,
    errors: errorsAr,
  },
}
